export default __webpack_public_path__ + "static/playstation-fdefcb8004c5f14a59c11064bfdc0ad7.webm";